import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Iter61d — Register PWA service worker for Web Push notifications
// Iter 62bh — Auto-check for SW updates every 5 minutes so the UpdateBanner
// can appear even when the client doesn't reload the page for hours.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      // Periodic update check — the browser will re-fetch /sw.js and detect
      // any byte-level change coming from a redeploy.
      setInterval(() => { reg.update().catch(() => {}); }, 5 * 60 * 1000);
    }).catch((err) => {
      console.warn('[SW] register failed', err);
    });
  });
  // Handle deep-link from push notification click
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type === 'push-navigate' && event.data.url) {
      // Only navigate if URL is different from current
      if (window.location.pathname + window.location.search !== event.data.url) {
        window.location.href = event.data.url;
      }
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
